module.exports = __webpack_public_path__ + "media/images/emblems/Soazza_wappen-a9f81369a66b0aac269702786b67ea66.svg";